import { render, staticRenderFns } from "./BookingSidebar.vue?vue&type=template&id=4e394f04&scoped=true&"
import script from "./BookingSidebar.vue?vue&type=script&lang=js&"
export * from "./BookingSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e394f04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tunabaranurut/Documents/Workgrounds/Cruise/Repo/panel-spa/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e394f04')) {
      api.createRecord('4e394f04', component.options)
    } else {
      api.reload('4e394f04', component.options)
    }
    module.hot.accept("./BookingSidebar.vue?vue&type=template&id=4e394f04&scoped=true&", function () {
      api.rerender('4e394f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/booking/BookingSidebar.vue"
export default component.exports